import React from 'react';
import './StandardCreditCardOffer.scss';

const RegularAPR = ({ datatestid, aprDetails }) => {
  return (
    <div className="cardAttributes__block introPurchaseBlock RegularAPRBlock">
      <div className="cardAttributes__blockTitle regularAPRTitle">
        Regular APR
      </div>
      <div className="cardAttributes__blockContent regularAPR">
        <div
          className="regularAPRText"
          data-testid={datatestid ? `${datatestid}-value` : null}
          dangerouslySetInnerHTML={{
            __html: aprDetails,
          }}
        />
      </div>
    </div>
  );
};

export default RegularAPR;
